    var loc = "/account/signin.tmpl?RETURN_URL=/products/19616/product-catalog/makeup/tools-more/victoria-beckham";
	var page_url = "/products/19616/product-catalog/makeup/tools-more/victoria-beckham";
    var site = window.site || {};
    var signed_in = typeof site.userInfoCookie == 'undefined' ? 0 : site.userInfoCookie.getValue('signed_in');
    signed_in = parseInt(signed_in, 10);

    if(window.location.pathname == page_url && signed_in != 1){
        window.location = loc;
    }